<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Cargos | Editar" />
    <form-role v-model="model" @submit="submit" />
  </section>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import { useRoute } from 'vue-router'
import TPageTitle from '@/components/TPageTitle.vue'
import Role from '@/types/Role'
import RoleService from '@/services/RoleService'
import Ability from '@/types/Ability'
import FormRole from './form-role.vue'
import { useDialog } from '@/stores/dialog'

const route = useRoute()
const loader = useLoader()
const snackbar = useSnackBar()
const dialog = useDialog()

const model = ref<Role>({ title: '', abilities: [] as Ability[] } as Role)

async function fetch() {
  try {
    loader.increment()

    const response = await (new RoleService()).show(route.params.id as string)

    model.value = response.data.data
  } finally {
    loader.decrement()
  }
}

async function submit() {
  const confirm = await dialog.open({
    title: 'Confirmação de edição',
    message: 'Realmente deseja alterar este cargo?',
  })

  if (!confirm) return

  try {
    loader.increment()

    await (new RoleService()).update(route.params.id as string, model.value)

    snackbar.show(
      'Cargo atualizado com sucesso',
      'success',
    )
  } finally {
    loader.decrement()
  }
}

onMounted(() => fetch())
</script>
